module.exports = __webpack_public_path__ + "fonts/c653ba84a6ad147888cf69019bce2d01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_europe_selected_area2.svg
// module id = 1530
// module chunks = 0